import { Injectable } from '@angular/core';
import { DatasourceGitService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { Y42GitFolders } from '@y42/feature/git';
import { GitQuery, GitService } from '@y42/git';
import { SqlModelingSettingsGitModel } from './sql-modeling.model';

@Injectable({ providedIn: 'root' })
export class SqlModelingGitService extends DatasourceGitService {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      name: 'Model',
      type: Y42GitFolders.SqlModel,
      git,
      gitQuery,
      errorHandlerService,
      settingsGitModel: SqlModelingSettingsGitModel,
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          childType: 'folder',
        },
        2: {
          modelType: 'folder',
          models: {
            tests: {
              fileName: 'tests.json',
            },
          },
        },
      },
    });
  }

  async writeSqlContentToFile(path: string, sqlQuery: string) {
    await this.git.writeFile({ path, content: sqlQuery, skipSync: false });
  }
}
